import { useAppSelector, useAppDispatch } from "hooks/store"; // === ADDED BY SAMPATH – 2026-01-29 === (useAppDispatch added) // === END SAMPATH ===
import React, { useEffect, useMemo, useRef, useState } from "react"; // === ADDED BY SAMPATH – 2026-01-06 ===
import { useSearchParams, useLocation } from "react-router-dom"; // === ADDED BY SAMPATH – 2026-02-02 === (useLocation added to detect /admin routes) // === END SAMPATH ===
import { format, setHours, setMinutes } from "date-fns";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"; // === ADDED BY SAMPATH – 2026-01-06 ===
import ChevronRightIcon from "@mui/icons-material/ChevronRight"; // === ADDED BY SAMPATH – 2026-01-06 ===
import MenuIcon from "@mui/icons-material/Menu"; // === ADDED BY SAMPATH – 2026-01-06 ===
import CloseIcon from "@mui/icons-material/Close"; // === ADDED BY SAMPATH – 2026-01-06 ===
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

// === ADDED BY SAMPATH – 2026-01-29 ===
// Delivery type toggle action (same pattern as DeliveryTypePopUp.tsx)
import { setdeliveryType } from "store/slices/main.slice";
// === END SAMPATH ===
import { convertToTimezone } from "utils";
import { ORDER, TIME_ZONES } from "utils/constants";
import { useCachedImage } from "hooks/useCachedImage";

const formatGlobalTime = (timeZone: string) => {
  const formattedTime = convertToTimezone(new Date(), TIME_ZONES[timeZone]);
  const [date, time] = formattedTime.split(", ");
  const [mon, day, year] = date.split("/");
  let [hr, min, sec]: string[] | number[] = time.split(":");

  const isPM = time.includes("PM");
  hr = isPM ? (hr === "12" ? 12 : +hr + 12) : hr === "12" ? 0 : +hr;
  sec = sec ? sec.replace(/ AM| PM/, "") : "0";

  const currentTime = new Date();
  currentTime.setMonth(+mon - 1);
  currentTime.setDate(+day);
  currentTime.setFullYear(+year);
  currentTime.setHours(+hr, +min, +sec);
  return currentTime;
};

const CATEGORY_BUTTON_STYLE = `
  .dcs-category-pill{
    position: relative;
    overflow: hidden;
    z-index: 1;
    border-radius: 999px;
    border: 1px solid #e8e8e8;
    background: #e8e8e8;
    color: #090909;
    box-shadow: 4px 4px 10px #c5c5c5, -4px -4px 10px #ffffff;
    transition: all .2s ease-in;
  }
  .dcs-category-pill::before,
  .dcs-category-pill::after{
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    z-index: -1;
    transition: all .5s .1s cubic-bezier(.55, 0, .1, 1);
    pointer-events: none;
  }
  .dcs-category-pill::before{
    left: 50%;
    top: 100%;
    width: 140%;
    height: 180%;
    transform: translateX(-50%) scaleY(1) scaleX(1.25);
    background-color: rgba(var(--color-primary) / .08);
  }
  .dcs-category-pill::after{
    left: 55%;
    top: 180%;
    width: 160%;
    height: 190%;
    transform: translateX(-50%) scaleY(1) scaleX(1.45);
    background-color: rgb(var(--color-primary));
  }
  .dcs-category-pill:hover{
    color: rgb(var(--color-themeSelColor));
    border-color: rgb(var(--color-primary));
  }
  .dcs-category-pill:hover::before{
    top: -35%;
    background-color: rgb(var(--color-primary));
    transform: translateX(-50%) scaleY(1.3) scaleX(.8);
  }
  .dcs-category-pill:hover::after{
    top: -45%;
    background-color: rgb(var(--color-primary));
    transform: translateX(-50%) scaleY(1.3) scaleX(.8);
  }
  .dcs-category-pill-active{
    background: rgb(var(--color-primary));
    border-color: rgb(var(--color-primary));
    color: rgb(var(--color-themeSelColor));
    box-shadow: 0 10px 22px rgba(15,23,42,.16);
  }
  .dcs-category-pill-active::before,
  .dcs-category-pill-active::after{
    display: none;
  }
`;

const HorizontalMenu = () => {
  const sideBarMenu = useAppSelector(({ main }) => main.sideBarMenu);
  const availableMenuCategoryIds = useAppSelector(
    ({ main }) => main.availableMenuCategoryIds
  );
  const displayOption = useAppSelector(({ main }) => main.settings.DeptDisplayOption);
  const visibleSideBarMenu = useMemo(() => {
    if (!availableMenuCategoryIds) return sideBarMenu;

    const visibleIds = new Set(availableMenuCategoryIds.map((id) => Number(id)));
    return sideBarMenu.filter(({ id }) => visibleIds.has(Number(id)));
  }, [availableMenuCategoryIds, sideBarMenu]);

  // === ADDED BY SAMPATH – 2026-01-29 ===
  // Header info + delivery type toggle
  const dispatch = useAppDispatch();
  const { settings, companyData, deliveryType, validTimes, cart } = useAppSelector(
    ({ main }) => main,
  );

  // === ADDED BY SAMPATH – 2026-02-02 ===
  // Premium/refined font stack (less blocky) + smoothing
  // Uses safe system fonts (no external font download needed)
  const premiumFont =
    'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Inter, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif';
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-29 ===
  // FIX: Banner must come from API ONLY (NO static fallback)
  // Also fix wrong /RangerAPI/{store}/Upload/... URL to correct /Upload/... using CURRENT FRONT DOMAIN
  const resolveUploadUrl = (raw: any): string => {
    if (!raw || typeof raw !== "string") return "";

    let url = raw.trim();
    if (!url) return "";

    const origin =
      typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";

    url = url.replace(/\\/g, "/");

    // filename only => /Upload/filename
    if (!/^https?:\/\//i.test(url) && !url.includes("/")) {
      return origin ? `${origin}/Upload/${url}` : `/Upload/${url}`;
    }

    // relative path => attach to current origin
    if (!/^https?:\/\//i.test(url)) {
      const p = url.startsWith("/") ? url : `/${url}`;
      return origin ? `${origin}${p}` : p;
    }

    // WRONG pattern includes /RangerAPI/{store}/Upload/... => use current origin + /Upload/...
    if (url.includes("/RangerAPI/") && url.includes("/Upload/")) {
      const idx = url.indexOf("/Upload/");
      const tail = idx >= 0 ? url.substring(idx) : "";
      return origin ? `${origin}${tail}` : tail;
    }

    // If it contains "/Upload/" and you want always front-domain banner, remap to origin
    if (url.includes("/Upload/") && origin) {
      const idx = url.indexOf("/Upload/");
      const tail = idx >= 0 ? url.substring(idx) : "";
      return tail ? `${origin}${tail}` : url;
    }

    return url;
  };

  // Read banner url from API settings (keep multi-key support)
  const bannerUrlFromApi =
    (settings as any)?.HeaderBannerUrl ||
    (settings as any)?.headerBannerUrl ||
    (settings as any)?.HeaderBanner ||
    (settings as any)?.headerBanner ||
    (settings as any)?.BannerUrl ||
    (settings as any)?.bannerUrl ||
    (settings as any)?.banner ||
    (settings as any)?.HeaderImage ||
    (settings as any)?.headerImage ||
    (companyData as any)?.headerBannerUrl ||
    (companyData as any)?.bannerUrl ||
    (companyData as any)?.banner;

  const bannerUrl = useMemo(() => resolveUploadUrl(bannerUrlFromApi), [bannerUrlFromApi]);

  const pickupEstimateLabel = useMemo(() => {
    const pickupMinutes = Number(companyData?.pickUpTime || 0);
    return `${pickupMinutes}–${pickupMinutes + 10} mins`;
  }, [companyData?.pickUpTime]);

  const deliveryEstimateLabel = useMemo(() => {
    const deliveryMinutes = Number(companyData?.deliveryTime || 0);
    return `${deliveryMinutes}–${deliveryMinutes + 10} mins`;
  }, [companyData?.deliveryTime]);

  // For testing: show what API returned (raw)
  const bannerDebugRaw = useMemo(
    () => (typeof bannerUrlFromApi === "string" ? bannerUrlFromApi : ""),
    [bannerUrlFromApi]
  );
  const primaryBannerUrl = useMemo(() => {
    const raw = bannerDebugRaw.trim();
    const resolved = bannerUrl.trim();

    if (/^https?:\/\//i.test(raw) || raw.startsWith("/")) return raw;
    return resolved || raw;
  }, [bannerDebugRaw, bannerUrl]);
  const bannerCandidates = useMemo(
    () => Array.from(new Set([primaryBannerUrl, bannerUrl].filter(Boolean))),
    [bannerUrl, primaryBannerUrl]
  );
  const cachedBannerUrl = useCachedImage(primaryBannerUrl, { cacheKey: "header-banner" });

  // === ADDED BY SAMPATH – 2026-01-29 ===
  // Toggle banner URL debug UI (HIDE by default)
  const SHOW_BANNER_DEBUG = false; // set true only when testing
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-29 ===
  // NEW: Use API RAW URL as banner image src (testing)
  // If RAW fails, auto-try RESOLVED (still API-based). No static fallback.
  const [bannerImgSrc, setBannerImgSrc] = useState<string>("");

  useEffect(() => {
    setBannerImgSrc(cachedBannerUrl || primaryBannerUrl || bannerUrl || "");
  }, [bannerUrl, cachedBannerUrl, primaryBannerUrl]);
  // === END SAMPATH ===

  const locationText = useMemo(() => {
    const a1 = (companyData?.address1 ?? "").trim();
    const a2 = (companyData?.address2 ?? "").trim();
    const full = `${a1}${a1 && a2 ? " " : ""}${a2}`.trim();
    return full;
  }, [companyData?.address1, companyData?.address2]);

  const activeType = (deliveryType === "pickup" ? "pickup" : "delivery") as "pickup" | "delivery";
  const todayName = useMemo(() => {
    const now = companyData?.timeZone ? formatGlobalTime(companyData.timeZone) : new Date();
    return format(now, "EEEE");
  }, [companyData?.timeZone]);

  const getTodayTimeConfig = (type: "pickup" | "delivery") =>
    validTimes.find(
      (item: any) =>
        item.timDay === todayName &&
        item.timOrdtype === (type === "delivery" ? ORDER.DELIVERY : ORDER.TAKE_OUT)
    );

  const pickupTimeConfig = getTodayTimeConfig("pickup");
  const deliveryTimeConfig = getTodayTimeConfig("delivery");

  const isPickupDisabled = !!settings?.ClosePickupOrder;
  const isDeliveryDisabled = !!settings?.CloseDeliveryOrder;
  const deliveryUnavailableMessage =
    isDeliveryDisabled && !isPickupDisabled ? "Delivery will be available soon" : "";
  const pickupUnavailableMessage =
    isPickupDisabled && !isDeliveryDisabled ? "Pickup not available today" : "";
  const allOrderingUnavailableMessage =
    isPickupDisabled && isDeliveryDisabled ? "We’re not accepting orders today" : "";
  const minimumDeliveryEnabled = Number((settings as any)?.MinimumDeliveryOrder || 0) === 1;
  const minimumDeliveryAmount = Number((settings as any)?.MinimumDeliveryOrderAmt || 0);
  const cartSubTotal = useMemo(
    () =>
      (cart || []).reduce((total: number, item: any) => {
        const itemSubTotal =
          item?.data && item?.data?.selectedDealPizzas
            ? Number(item?.subTotal || 0)
            : Number(item?.subTotal || 0);

        return total + itemSubTotal;
      }, 0),
    [cart],
  );
  const minimumDeliveryRemaining = Math.max(0, minimumDeliveryAmount - cartSubTotal);
  const minimumDeliveryProgress =
    minimumDeliveryAmount > 0
      ? Math.min(100, Math.max(0, (cartSubTotal / minimumDeliveryAmount) * 100))
      : 0;
  const minimumDeliveryProgressClass =
    minimumDeliveryProgress >= 100
      ? "bg-emerald-500"
      : minimumDeliveryProgress < 50
      ? "bg-red-500"
      : minimumDeliveryProgress < 90
      ? "bg-yellow-400"
      : "bg-gradient-to-r from-yellow-400 to-emerald-500";
  const showMinimumDeliveryMessage =
    activeType === "delivery" && minimumDeliveryEnabled && minimumDeliveryAmount > 0;
  const minimumDeliveryTitle = `Delivery minimum $${minimumDeliveryAmount.toFixed(2)}`;
  const minimumDeliveryBalanceText =
    cartSubTotal > 0 && minimumDeliveryRemaining > 0
      ? `Add $${minimumDeliveryRemaining.toFixed(2)} more`
      : cartSubTotal >= minimumDeliveryAmount
      ? "Delivery Minimum Reached"
      : "";
  const onlineSpecialDiscountPercent = Number(settings?.OnlineSpecialDiscount || 0);
  const allowPickupDiscount = !!Number(settings?.AllowDiscountOnPickup);
  const allowDeliveryDiscount = !!Number(settings?.AllowDiscountOnDelivery);
  const showHeaderDiscountNotice =
    onlineSpecialDiscountPercent > 0 && (allowPickupDiscount || allowDeliveryDiscount);

  const headerDiscountText = useMemo(() => {
    if (!showHeaderDiscountNotice) return "";

    if (allowPickupDiscount && allowDeliveryDiscount) {
      return `Online special: ${onlineSpecialDiscountPercent}% off your order`;
    }

    if (allowDeliveryDiscount) {
      return `Special discount: ${onlineSpecialDiscountPercent}% off delivery orders`;
    }

    return `Special discount: ${onlineSpecialDiscountPercent}% off pickup orders`;
  }, [
    allowDeliveryDiscount,
    allowPickupDiscount,
    onlineSpecialDiscountPercent,
    showHeaderDiscountNotice,
  ]);

  const switchType = (type: "pickup" | "delivery") => {
    if (type === "pickup" && isPickupDisabled) return;
    if (type === "delivery" && isDeliveryDisabled) return;
    dispatch(setdeliveryType(type));
  };

  const onlineOrderingHours = useMemo(() => {
    const timeConfig = activeType === "delivery" ? deliveryTimeConfig : pickupTimeConfig;

    if (timeConfig?.timEnable === 0) return "Closed today";
    if (timeConfig?.timIs24Hr) return "Open 24 hours";

    const windows = [
      timeConfig?.timFrom && timeConfig?.timTo
        ? { from: new Date(timeConfig.timFrom), to: new Date(timeConfig.timTo) }
        : null,
      timeConfig?.timFrom1 && timeConfig?.timTo1
        ? { from: new Date(timeConfig.timFrom1), to: new Date(timeConfig.timTo1) }
        : null,
      timeConfig?.timFrom2 && timeConfig?.timTo2
        ? { from: new Date(timeConfig.timFrom2), to: new Date(timeConfig.timTo2) }
        : null,
    ].filter(Boolean) as Array<{ from: Date; to: Date }>;

    const validWindows = windows.filter(
      (window) => !Number.isNaN(window.from.getTime()) && !Number.isNaN(window.to.getTime())
    );

    if (validWindows.length) {
      return validWindows
        .map(
          (window) =>
            `${format(window.from, "h:mma").toUpperCase()} - ${format(window.to, "h:mma").toUpperCase()}`
        )
        .join(", ");
    }

    const rawFrom =
      activeType === "delivery" ? companyData?.delvtimefrom : companyData?.servicetimefrom;
    const rawTo =
      activeType === "delivery" ? companyData?.delvtimeto : companyData?.servicetimeto;

    if (!rawFrom || !rawTo) return "";

    const from = new Date(rawFrom);
    const to = new Date(rawTo);

    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return "";

    return `${format(from, "h:mma").toUpperCase()} - ${format(to, "h:mma").toUpperCase()}`;
  }, [
    activeType,
    deliveryTimeConfig,
    pickupTimeConfig,
    companyData?.delvtimefrom,
    companyData?.delvtimeto,
    companyData?.servicetimefrom,
    companyData?.servicetimeto,
  ]);

  const isOnlineOrderingOpenNow = useMemo(() => {
    const timeConfig = activeType === "delivery" ? deliveryTimeConfig : pickupTimeConfig;
    const settingClosed = activeType === "delivery" ? isDeliveryDisabled : isPickupDisabled;
    if (settingClosed || timeConfig?.timEnable === 0) return false;
    if (timeConfig?.timIs24Hr) return true;

    const now = companyData?.timeZone ? formatGlobalTime(companyData.timeZone) : new Date();
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);

    const windows = [
      timeConfig?.timFrom && timeConfig?.timTo
        ? { from: new Date(timeConfig.timFrom), to: new Date(timeConfig.timTo) }
        : null,
      timeConfig?.timFrom1 && timeConfig?.timTo1
        ? { from: new Date(timeConfig.timFrom1), to: new Date(timeConfig.timTo1) }
        : null,
      timeConfig?.timFrom2 && timeConfig?.timTo2
        ? { from: new Date(timeConfig.timFrom2), to: new Date(timeConfig.timTo2) }
        : null,
    ].filter(Boolean) as Array<{ from: Date; to: Date }>;

    return windows.some((window) => {
      if (Number.isNaN(window.from.getTime()) || Number.isNaN(window.to.getTime())) {
        return false;
      }

      const from = setHours(setMinutes(today, window.from.getMinutes()), window.from.getHours());
      const to = setHours(setMinutes(today, window.to.getMinutes()), window.to.getHours());
      return now >= from && now <= to;
    });
  }, [
    activeType,
    companyData?.timeZone,
    deliveryTimeConfig,
    isDeliveryDisabled,
    isPickupDisabled,
    pickupTimeConfig,
  ]);
  // === END SAMPATH ===

  const [searchParams, setSearchParams] = useSearchParams();
  const product = useMemo(() => +(searchParams.get("product") || 0), [searchParams]);

  const scrollRef = useRef<HTMLDivElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // === ADDED BY SAMPATH – 2026-02-02 ===
  // Ensure ALL text inherits premium font (including inline styles)
  const fontInherit = premiumFont;
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-02-02 ===
  // HIDE the left Menu icon on Admin pages (ex: /admin/inventory?product=3)
  // This prevents showing the customer "Full Menu" drawer inside admin screens.
  const routerLocation = useLocation();
  const hideCustomerMenuIcon = useMemo(() => {
    const p = (routerLocation?.pathname || "").toLowerCase();
    return p.startsWith("/admin");
  }, [routerLocation?.pathname]);

  const showCustomerMenuIcon = !hideCustomerMenuIcon;
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-02-02 ===
  // HIDE the TOP BANNER + HEADER CARD on Admin pages (ex: /admin/inventory?product=1)
  // Keeps only the sticky category row visible for admin screens.
  const hideTopBannerOnAdmin = hideCustomerMenuIcon;
  // === END SAMPATH ===

  const activeBgClass = "bg-primary/10";
  const hoverBgClass = "hover:bg-primary/10";
  const activeTextClass = "text-primary";
  const normalTextClass = "text-deptColor";

  const updateArrows = () => {
    const el = scrollRef.current;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    const left = el.scrollLeft;
    setCanLeft(left > 2);
    setCanRight(left < max - 2);
  };

  useEffect(() => {
    updateArrows();
    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => updateArrows();
    el.addEventListener("scroll", onScroll, { passive: true });

    const ro = new ResizeObserver(() => updateArrows());
    ro.observe(el);

    const t = window.setTimeout(updateArrows, 50);

    return () => {
      el.removeEventListener("scroll", onScroll as any);
      ro.disconnect();
      window.clearTimeout(t);
    };
  }, [visibleSideBarMenu.length]);

  const scroll = (dir: "left" | "right") => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({
      left: dir === "left" ? -240 : 240,
      behavior: "smooth",
    });
  };

  // Close menu on ESC + lock page scroll while menu open
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);

    const prev = document.body.style.overflow;
    if (menuOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = prev || "";

    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev || "";
    };
  }, [menuOpen]);

  // animate panel open smoothly (slide from left)
  useEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    const r = requestAnimationFrame(() => {
      el.classList.remove("-translate-x-full");
      el.classList.add("translate-x-0");
    });
    return () => cancelAnimationFrame(r);
  }, [menuOpen]);

  const closeWithSlide = () => {
    const el = panelRef.current;
    if (!el) return setMenuOpen(false);
    el.classList.remove("translate-x-0");
    el.classList.add("-translate-x-full");
    window.setTimeout(() => setMenuOpen(false), 220);
  };

  // === ADDED BY SAMPATH – 2026-01-12 ===
  const fireCategoryScroll = (id: number) => {
    window.dispatchEvent(new CustomEvent("dcs:categoryScroll", { detail: { id } }));
  };
  // === END SAMPATH ===

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const active = el.querySelector(`[data-cat-btn="${product}"]`) as HTMLElement | null;
    if (!active) return;

    active.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [product]);

  useEffect(() => {
    if (!availableMenuCategoryIds || !visibleSideBarMenu.length) return;
    if (visibleSideBarMenu.some(({ id }) => Number(id) === product)) return;

    const firstVisibleId = Number(visibleSideBarMenu[0]?.id || 0);
    if (!firstVisibleId) return;
    const nextSearch = new URLSearchParams(searchParams);
    nextSearch.set("product", String(firstVisibleId));
    setSearchParams(nextSearch, { replace: true });
    fireCategoryScroll(firstVisibleId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableMenuCategoryIds, product, visibleSideBarMenu]);

  // === ADDED BY SAMPATH – 2026-01-29 ===
  const headerWrapRef = useRef<HTMLDivElement>(null);
  const [isCompactSticky, setIsCompactSticky] = useState(false);
  const [stickyOffsetTop, setStickyOffsetTop] = useState<number>(0);

  // === ADDED BY SAMPATH – 2026-03-16 ===
  // Smooth scroll-wise hide progress for current header design
  const [headerHideProgress, setHeaderHideProgress] = useState(0);
  const HEADER_SMOOTH_HIDE_DISTANCE = 180;
  // === END SAMPATH ===

  useEffect(() => {
    const calcTop = () => {
      const possibleToolbars = [
        document.querySelector('[data-dcs-toolbar="true"]') as HTMLElement | null,
        document.querySelector(".dcs-toolbar") as HTMLElement | null,
      ].filter(Boolean) as HTMLElement[];

      const h = possibleToolbars.length ? possibleToolbars[0].getBoundingClientRect().height : 0;
      setStickyOffsetTop(Math.max(0, Math.round(h)));
    };

    calcTop();
    window.addEventListener("resize", calcTop);
    return () => window.removeEventListener("resize", calcTop);
  }, []);

  useEffect(() => {
    const getScrollEl = () =>
      document.querySelector('[data-dcs-product-scroll="true"]') as HTMLElement | null;

    let raf = 0;

    const onProductsScroll = () => {
      const el = getScrollEl();
      if (!el) return;

      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const top = Math.max(0, el.scrollTop || 0);

        // === ADDED BY SAMPATH – 2026-03-16 ===
        // Scroll-wise smooth hide instead of instant jump hide
        const progress = Math.min(top / HEADER_SMOOTH_HIDE_DISTANCE, 1);
        setHeaderHideProgress(progress);
        setIsCompactSticky(progress >= 0.995);
        window.dispatchEvent(
          new CustomEvent("dcs:headerProgress", {
            detail: { progress, isBannerFullyVisible: progress <= 0.02 },
          })
        );
        // === END SAMPATH ===
      });
    };

    const el = getScrollEl();
    if (el) {
      el.addEventListener("scroll", onProductsScroll, { passive: true });
      onProductsScroll();
    } else {
      setIsCompactSticky(false);
      // === ADDED BY SAMPATH – 2026-03-16 ===
      setHeaderHideProgress(0);
      // === END SAMPATH ===
    }

    return () => {
      if (raf) cancelAnimationFrame(raf);
      if (el) el.removeEventListener("scroll", onProductsScroll as any);
    };
  }, []);
  // === END SAMPATH ===

  return (
    // === ADDED BY SAMPATH – 2026-02-02 ===
    // Apply premium font + smoothing at the very top wrapper (affects whole page area)
    <div
      className="relative bg-white antialiased"
      style={{
        fontFamily: premiumFont,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
      }}
    >
      {/* === END SAMPATH === */}

      {/* === ADDED BY SAMPATH – 2026-02-02 === */}
      {/* Hide Banner/Header block on /admin routes */}
      {!hideTopBannerOnAdmin && (
        <div
          ref={headerWrapRef}
          className="w-full bg-white overflow-hidden"
          // === ADDED BY SAMPATH – 2026-03-16 ===
          style={{
            maxHeight: `${Math.max(0, 460 * (1 - headerHideProgress))}px`,
            opacity: Math.max(0, 1 - headerHideProgress * 1.15),
            transform: `translateY(-${headerHideProgress * 32}px)`,
            pointerEvents: headerHideProgress > 0.96 ? "none" : "auto",
            willChange: "max-height, opacity, transform",
          }}
          // === END SAMPATH ===
        >
          {/* === ADDED BY SAMPATH – 2026-03-16 === */}
          {/* Keep current design, only add smooth scroll-wise collapse */}
          <div
            style={{
              transform: `scale(${1 - headerHideProgress * 0.025})`,
              transformOrigin: "top center",
              willChange: "transform",
            }}
          >
            {/* === END SAMPATH === */}
            {!isCompactSticky && (
              <>
                {/* === ADDED BY SAMPATH – 2026-01-29 === */}
                {/* TESTING (optional): show ONLY ONE URL (API Raw) */}
                {SHOW_BANNER_DEBUG && (
                  <div className="px-4 sm:px-6 pt-3">
                    <div className="text-[12px] break-all rounded-xl border border-black/10 bg-black/5 px-3 py-2">
                      <div className="font-semibold text-black/70">Banner URL (API Raw):</div>
                      <div className="text-black/60">{bannerDebugRaw || "(empty from API)"}</div>
                    </div>
                  </div>
                )}
                {/* === END SAMPATH === */}

                {/* Banner (API ONLY) */}
                <div className="relative w-full h-[150px] sm:h-[190px] md:h-[220px] overflow-hidden rounded-b-2xl">
                  {/* === ADDED BY SAMPATH – 2026-01-29 === */}
                  {/* Use API RAW as image src (requested). If RAW fails, try RESOLVED. */}
                  {bannerImgSrc ? (
                    <img
                      src={bannerImgSrc}
                      alt="Store banner"
                      className="w-full h-full object-cover"
                      loading="eager"
                      draggable={false}
                      onError={(e) => {
                        const current = e.currentTarget.currentSrc || e.currentTarget.src;
                        const failedIndex = bannerCandidates.findIndex((candidate) => {
                          try {
                            return new URL(candidate, window.location.origin).toString() === current;
                          } catch {
                            return candidate === bannerImgSrc;
                          }
                        });
                        const nextCandidate = bannerCandidates[failedIndex + 1];

                        if (nextCandidate) {
                          setBannerImgSrc(nextCandidate);
                          return;
                        }

                        // If both failed -> hide (API only, no static fallback)
                        setBannerImgSrc("");
                      }}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-[13px] font-semibold text-black/50 bg-black/5">
                      Banner URL not available from API
                    </div>
                  )}
                  {/* === END SAMPATH === */}

                  <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
                </div>
              </>
            )}

            {/* Content card (hide when product scroll down) */}
            {!isCompactSticky && (
              <div className="px-4 sm:px-6 -mt-10 pb-3 sm:pb-3">
                <div className="bg-white/92 backdrop-blur-md rounded-2xl shadow-[0px_10px_25px_0px_#0000001a] border border-black/5 p-4">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
                    <div className="min-w-0 mt-5">
                      {!!settings?.ShowCompanyName && !!companyData?.companyName && (
                        <div className="mt-1 text-[22px] sm:text-[26px] font-extrabold text-black/90 leading-tight break-words">
                          {companyData?.companyName}
                        </div>
                      )}

                      {!!settings?.DisplayLocationOnCheckout && !!locationText && (
                        <div className="mt-1 text-[13px] sm:text-[14px] text-black/60 break-words">
                          {locationText}
                        </div>
                      )}

                      {!!onlineOrderingHours && (
                        <div
                          className={`mt-1 text-[13px] sm:text-[14px] break-words ${
                            isOnlineOrderingOpenNow ? "text-black/75" : "text-red-600"
                          }`}
                        >
                          <span
                            className={`font-semibold ${
                              isOnlineOrderingOpenNow ? "text-black/80" : "text-red-700"
                            }`}
                          >
                            Online ordering hours:
                          </span>{" "}
                          {onlineOrderingHours}
                        </div>
                      )}

                      <div className="mt-3 inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-black/10 bg-white/70 backdrop-blur-sm">
                        <span className="text-[12px] sm:text-[13px] font-semibold text-black/70">
                          Estimated Pickup:{" "}
                          <span className="text-black/80">{pickupEstimateLabel}</span>
                        </span>
                        <span className="text-black/25">|</span>
                        <span className="flex flex-col text-[12px] sm:text-[13px] font-semibold text-black/70">
                          <span>
                            Delivery: <span className="text-black/80">{deliveryEstimateLabel}</span>
                          </span>
                          {!!deliveryUnavailableMessage && (
                            <span className="mt-1 text-[12px] font-[700] leading-none text-red-600">
                              {deliveryUnavailableMessage}
                            </span>
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="flex flex-col items-start gap-2 md:items-end md:pt-5">
                      <div className="relative inline-grid select-none grid-cols-2 rounded-full bg-[#f3f4f6] p-1 shadow-inner">
                        <span
                          className={`absolute bottom-1 top-1 w-[calc(50%-4px)] rounded-full bg-primary shadow-[0_1px_4px_rgba(15,23,42,0.14)] transition-transform duration-300 ease-out ${
                            activeType === "pickup" ? "translate-x-full" : ""
                          }`}
                          style={{ left: "4px" }}
                        />
                        <button
                          type="button"
                          onClick={() => switchType("delivery")}
                          disabled={isDeliveryDisabled}
                          className={`relative z-10 px-4 py-1.5 rounded-full text-[13px] font-[700] transition-colors duration-300 ease-out ${
                            activeType === "delivery"
                              ? "text-themeSelColor"
                              : "bg-transparent text-[#111827]"
                          } ${isDeliveryDisabled ? "opacity-40 cursor-not-allowed" : ""}`}
                        >
                          Delivery
                        </button>

                        <button
                          type="button"
                          onClick={() => switchType("pickup")}
                          disabled={isPickupDisabled}
                          className={`relative z-10 px-4 py-1.5 rounded-full text-[13px] font-[700] transition-colors duration-300 ease-out ${
                            activeType === "pickup"
                              ? "text-themeSelColor"
                              : "bg-transparent text-[#111827]"
                          } ${isPickupDisabled ? "opacity-40 cursor-not-allowed" : ""}`}
                        >
                          Pickup
                        </button>
                      </div>

                      {showHeaderDiscountNotice && (
                        <div className="inline-flex w-full max-w-[380px] items-center gap-2.5 rounded-xl border border-red-200 bg-white px-3.5 py-2.5 text-left shadow-[0_8px_20px_rgba(220,38,38,0.08)]">
                          <span className="inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-[#f10505] px-1.5 text-[11px] font-[900] leading-none text-white">
                            %
                          </span>
                          <span className="text-[13px] font-[800] leading-snug text-red-600">
                            {headerDiscountText}
                          </span>
                        </div>
                      )}

                      {showMinimumDeliveryMessage ? (
                        <div
                          className={`mt-2 w-full max-w-[380px] overflow-hidden rounded-xl border bg-white text-left shadow-none ${
                            minimumDeliveryRemaining > 0
                              ? "border-slate-200 text-slate-800"
                              : "border-emerald-200 text-emerald-800"
                          }`}
                        >
                          <div className="flex items-center gap-2 px-3 py-2">
                            {minimumDeliveryRemaining > 0 ? (
                              <LocalShippingOutlinedIcon className="!text-[17px] shrink-0 text-current" />
                            ) : (
                              <>
                                <LocalShippingOutlinedIcon className="!text-[17px] shrink-0 text-current" />
                                <CheckRoundedIcon className="!text-[17px] shrink-0 text-current" />
                              </>
                            )}
                            {minimumDeliveryRemaining > 0 ? (
                              <>
                                <span className="whitespace-nowrap text-[13px] font-semibold leading-snug text-black/75">
                                  {minimumDeliveryTitle}
                                </span>
                                <span className="h-1 w-1 rounded-full bg-slate-300" />
                                <span
                                  className={`whitespace-nowrap text-[13px] font-semibold leading-snug ${
                                    minimumDeliveryRemaining > 0
                                      ? "text-black/65"
                                      : "text-emerald-700"
                                  }`}
                                >
                                  {minimumDeliveryBalanceText}
                                </span>
                              </>
                            ) : (
                              <span className="whitespace-nowrap text-[13px] font-semibold leading-snug">
                                Delivery Minimum Reached
                              </span>
                            )}
                          </div>
                          <div className="h-[2px] bg-slate-100">
                            <div
                              className={`h-full rounded-r-full transition-all duration-300 ${minimumDeliveryProgressClass}`}
                              style={{ width: `${minimumDeliveryProgress}%` }}
                            />
                          </div>
                        </div>
                      ) : (
                        activeType === "pickup" &&
                        !!locationText && (
                          <div className="mt-2 flex w-full max-w-[380px] select-none items-center gap-2 overflow-hidden rounded-xl border border-slate-200 bg-white px-3 py-2 text-left text-[13px] font-semibold leading-snug text-black/75 shadow-none">
                            <StorefrontOutlinedIcon className="!text-[17px] shrink-0 text-current" />
                            <span>{locationText}</span>
                          </div>
                        )
                      )}
                    </div>
                  </div>

                  {(pickupUnavailableMessage || allOrderingUnavailableMessage) && (
                    <div className="mt-2 text-[12px] text-red-600 font-semibold">
                      {pickupUnavailableMessage || allOrderingUnavailableMessage}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {/* === ADDED BY SAMPATH – 2026-03-16 === */}
          {/* Smooth collapse wrapper end */}
          {/* === END SAMPATH === */}
        </div>
      )}
      {/* === END SAMPATH === */}

      {/* Category row MUST be under header and sticky */}
      <div
        data-dcs-category-row="true"
        className="sticky z-[50] bg-white border-b border-primary"
        style={{ top: `${stickyOffsetTop}px` }}
      >
        {/* === ADDED BY SAMPATH – 2026-02-02 === */}
        {/* Hide the Menu icon button on /admin routes */}
        {showCustomerMenuIcon && (
          <button
            onClick={() => setMenuOpen(true)}
            className="absolute left-2 top-1/2 -translate-y-1/2 z-30 bg-white/95 backdrop-blur-sm shadow-md rounded-full w-10 h-10 flex items-center justify-center hover:bg-white transition"
            aria-label="Open full menu"
          >
            <MenuIcon className="text-gray-700" />
          </button>
        )}
        {/* === END SAMPATH === */}

        {canLeft && (
          <div className="pointer-events-none absolute left-0 top-0 h-full w-10 bg-gradient-to-r from-white to-transparent z-10" />
        )}
        {canRight && (
          <div className="pointer-events-none absolute right-0 top-0 h-full w-10 bg-gradient-to-l from-white to-transparent z-10" />
        )}

        {canLeft && (
          <button
            onClick={() => scroll("left")}
            className={
              // === ADDED BY SAMPATH – 2026-02-02 ===
              // If menu icon hidden, move left arrow to the edge
              `absolute ${showCustomerMenuIcon ? "left-14" : "left-2"} top-1/2 -translate-y-1/2 z-20 bg-white/90 backdrop-blur-sm shadow-md rounded-full w-9 h-9 flex items-center justify-center hover:bg-white transition`
              // === END SAMPATH ===
            }
            aria-label="Scroll left"
          >
            <ChevronLeftIcon className="text-gray-700" />
          </button>
        )}

        {canRight && (
          <button
            onClick={() => scroll("right")}
            className="absolute right-2 top-1/2 -translate-y-1/2 z-20 bg-white/90 backdrop-blur-sm shadow-md rounded-full w-9 h-9 flex items-center justify-center hover:bg-white transition"
            aria-label="Scroll right"
          >
            <ChevronRightIcon className="text-gray-700" />
          </button>
        )}

        <div
          ref={scrollRef}
          style={{
            msOverflowStyle: "none",
            scrollbarWidth: "none",
            // === ADDED BY SAMPATH – 2026-02-02 ===
            // If menu icon hidden, remove reserved left space
            paddingLeft: showCustomerMenuIcon ? "56px" : "12px",
            // === END SAMPATH ===
            paddingRight: "44px",
            // === ADDED BY SAMPATH – 2026-02-02 ===
            fontFamily: fontInherit,
            // === END SAMPATH ===
          }}
          className="flex px-3 py-3 bg-white overflow-x-auto whitespace-nowrap"
        >
          <style>{`${CATEGORY_BUTTON_STYLE}.hide-h-scrollbar::-webkit-scrollbar { display: none; height: 0; }`}</style>

          <div className="flex space-x-4 hide-h-scrollbar">
            {visibleSideBarMenu.map(({ id, categoryDescription, imageUrl }) => (
              <div
                key={id}
                data-cat-btn={id}
                className={`dcs-category-pill capitalize py-2 px-4 cursor-pointer font-semibold flex gap-3 items-center ${
                  product === id ? "dcs-category-pill-active" : ""
                } flex-shrink-0`}
                style={{
                  // === ADDED BY SAMPATH – 2026-02-02 ===
                  fontFamily: fontInherit,
                  letterSpacing: "0.01em",
                  // === END SAMPATH ===
                }}
                onClick={() => {
                  fireCategoryScroll(Number(id));
                  let search = searchParams;
                  search.set("product", id.toString());
                  setSearchParams(search);
                }}
              >
                {["Image", "Both"].includes(displayOption) && !!imageUrl && (
                  <img src={imageUrl} alt="logo" className="w-8 h-8 rounded-full object-cover" />
                )}

                {["Text", "Both"].includes(displayOption) && (
                  <span className="block overflow-hidden overflow-ellipsis whitespace-nowrap max-w-[180px]">
                    {categoryDescription.toLowerCase()}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Drawer should never open on /admin because menu icon is hidden,
          but keep original behavior for non-admin routes */}
      {menuOpen && showCustomerMenuIcon && (
        <div className="fixed inset-0 z-[9999]">
          <div
            className="absolute inset-0 bg-black/40 opacity-100 transition-opacity duration-200"
            onClick={closeWithSlide}
          />

          <div
            ref={panelRef}
            className="absolute left-0 top-0 h-full w-[320px] max-w-[88vw] bg-white shadow-2xl rounded-tr-2xl rounded-br-2xl overflow-hidden transform -translate-x-full transition-transform duration-200 ease-out"
            style={{ fontFamily: fontInherit }}
          >
            <div className="flex items-center justify-between px-4 py-3 border-b border-black/10">
              <div
                className="font-semibold text-[15px] text-gray-900"
                style={{ fontFamily: fontInherit }}
              >
                Full Menu
              </div>

              <button
                onClick={closeWithSlide}
                className="bg-gray-100 hover:bg-gray-200 transition rounded-full w-9 h-9 flex items-center justify-center"
                aria-label="Close menu"
              >
                <CloseIcon className="text-gray-700" />
              </button>
            </div>

            <div
              className="px-2 py-2 overflow-y-auto"
              style={{ maxHeight: "calc(100vh - 56px)", fontFamily: fontInherit }}
            >
              {visibleSideBarMenu.map(({ id, categoryDescription }) => {
                const active = product === id;

                return (
                  <button
                    key={id}
                    onClick={() => {
                      fireCategoryScroll(Number(id));
                      let search = searchParams;
                      search.set("product", id.toString());
                      setSearchParams(search);
                      closeWithSlide();
                    }}
                    className={`w-full text-left px-3 py-2 rounded-lg flex items-center justify-between transition ${
                      active
                        ? `${activeBgClass} ${activeTextClass} font-semibold`
                        : `${hoverBgClass} ${normalTextClass} font-medium`
                    }`}
                    style={{
                      fontFamily: fontInherit,
                      // === ADDED BY SAMPATH – 2026-02-02 ===
                      letterSpacing: "0.01em",
                      // === END SAMPATH ===
                    }}
                  >
                    <span className="text-[13px] leading-5" style={{ fontFamily: fontInherit }}>
                      {categoryDescription}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HorizontalMenu;
